import React from "react";
/** MUI */
import { alpha, Box, Skeleton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    skeleton: {
        backgroundColor: alpha(theme.palette.primary.light, 0.21),
    },
    treeItem: {
        backgroundColor: alpha(theme.palette.primary.light, 0.21),
        height: 8,
        // marginRight: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        // margin:0,
        display: "inline-block",
    },
}));
const DimensionsSkeleton = () => {
    const classes = useStyles();
    return (
        <Box sx={{ mt: 2 }}>
            {[1, 2, 3].map((i) => (
                <Box key={i} sx={{ width: "100%", display: "flex", alignItems: "center", mb: 0 }}>
                    <Skeleton
                        sx={{ ml: 0, mt: 0 }}
                        className={classes.treeItem}
                        // animation="wave"
                        variant="rectangular"
                        width={4}
                        height={43}
                        style={{ backgroundColor: "transparent"}}
                    />
                    <Skeleton
                        sx={{ ml: 2, mt: 0 }}
                        className={classes.treeItem}
                        // animation="wave"
                        variant="rectangular"
                        width={"75%"}
                        height={8}
                    />
                    <Skeleton
                        sx={{ ml: 4 }}
                        // animation="wave"
                        variant="rectangular"
                        className={classes.treeItem}
                        width={"10%"}
                        height={8}
                    />
                </Box>
            ))}
        </Box>
    );
};

export default DimensionsSkeleton;
